import React from "react";
import { Layout } from "./Pages/Layout";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SessionManager from "./SessionManager";

function App() {
  return (
    <>
      <SessionManager />

      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

      <Routes>
        <Route path="*" element={<Layout />} />
      </Routes>
    </>
  );
}

export default App;
